module.exports = __webpack_public_path__ + "img/amigos_+18_sinpapeles.a2fb087b.webp";